import { useMutation } from '@tanstack/vue-query'
import KnowError from '~/exceptions/KnownError'
import { queryKeys } from '~/queryClient'
import financialBff from '~/services-v2/financial-bff/financial-bff'

export default function useRegisterPartnerCredentialsCheck(brand: Ref<string | undefined>) {
  const mutationKey = queryKeys.INSTALLATION.REGISTER_PARTNER_CREDENTIALS_CHECK(brand.value as string)

  const mutationFn = async ({ username, password }: {
    username: string
    password: string
  }) => {
    if (!brand.value) {
      throw new KnowError('BRAND_REQUIRED')
    }

    const res = await financialBff('mutation')({
      register_device_orchestrator_gateway_credential: [
        {
          input: {
            brand: brand.value.toLowerCase(),
            username,
            password,
          },
        },
        {
          success: true,
          message: true,
        },
      ],
    })

    return res.register_device_orchestrator_gateway_credential
  }

  return useMutation({
    mutationKey,
    mutationFn,
    retry: 0,
  })
}
